import {EntityFilters, SearchFilter} from "./types";
import * as qs from "qs";
import Entity from "../metamodel/Entity";
import IField, {FieldType} from "../metamodel/IField";
import EnumField from "../metamodel/Fields/EnumField";
import ArrayField from "../metamodel/Fields/ArrayField";
import {LengthInterval} from "./components/filters/LengthIntervalFilterField";
import LengthIntervalField from "../metamodel/Fields/LengthIntervalField";


export default class EntityFiltersSerializer {
    public static serialize(filters: EntityFilters, params: URLSearchParams) {
        params.set('filter', qs.stringify(filters));
        return params;
    }

    public static deserialize(entity: Entity, params: URLSearchParams): EntityFilters {
        const filter = params.get('filter');
        if (!filter) {
            return {};
        }
        const vals = qs.parse(filter);
        const filterFields = entity.fields.filter(f => f.searchable);
        const results = {};
        for (const field of filterFields) {
            if (vals[field.id]) {
                if (field.type === FieldType.Array) {
                    if (Array.isArray(vals[field.id])) {
                        const arrayVal = vals[field.id].map((v: any) => this.extractFieldValue(v, (field as ArrayField).innerField)).filter((f:any) => f);
                        if (arrayVal.length > 0) {
                            results[field.id] = arrayVal;
                        }
                    }
                } else {
                    const val = this.extractFieldValue(vals, field);
                    if (val) {
                        results[field.id] = val;
                    }
                }
            }
        }
        return results;
    }

    private static extractFieldValue(vals: any, field: IField) {
        const fieldValues = vals[field.id];
        if (field.type === FieldType.Enum) {
            return this.cleanEnum(field as EnumField, fieldValues);
        }
        if (field.type === FieldType.Boolean) {
            return this.cleanBool(fieldValues);
        }
        if (field.type === FieldType.Text) {
            return fieldValues.toString()
        }
        if (field.type === FieldType.LengthInterval) {
            return this.cleanLengthInterval(field as LengthIntervalField, fieldValues);
        }
    }

    private static cleanEnum(field: EnumField, filter: any): SearchFilter {
        if (Array.isArray(filter) && filter.every(it => typeof it === 'string')) {
            return filter.filter(f => field.options.map(o => o.key).indexOf(f) !== -1);
        }
        return [];
    }

    private static cleanBool(filter: any): SearchFilter {
        if (typeof filter === "string") {
            if (filter === "true") {
                return true;
            }
            if (filter === "false") {
                return false;
            }
        }
        return undefined;
    }

    private static cleanLengthInterval(field: LengthIntervalField, filter: any) : LengthInterval | undefined {
        if (typeof filter === 'object' && filter.min && filter.max) {
            const min = parseInt(filter.min, 10);
            const max = parseInt(filter.max, 10);
            if (min > max) {
                return undefined;
            }
            if (min < 0 || max < 0) {
                return undefined;
            }
            return { min, max};
        }
        return undefined;
    }
}


// WEBPACK FOOTER //
// ./src/homepage/EntityFiltersSerializer.ts